export const pending        = state => state.administradora.pending;
export const pendingInfo    = state => state.administradora.pendingInfo;
export const dataPatrimonio = state => state.administradora.dataPatrimonio;
export const dataUsuario    = state => state.administradora.dataUsuario;

export const administradoras= state => JSON.parse(JSON.stringify(state.administradora.administradoras));
export const cuentasAdministradoras= state => JSON.parse(JSON.stringify(state.administradora.cuentasAdministradoras));
export const pendingAccounts= state => state.administradora.pendingAccounts;

